import { message } from "ant-design-vue";
import { plugId } from "@/config";
// import {} from '@/api/lipin/api'
// import { SaveMyToken } from '@/api/pdd/base'
import { SetAgreeXueYiOK } from "../co_util";
// import md5 from 'js-md5'
import { MsgUtil_RequestInjectData } from "../msg_util";

var chrome = window.chrome;

var myPlugId = plugId;
function getPlugId() {
  var v = localStorage.getItem("zzbPlugId");
  // console.log("从本地缓存里找到数据"+v)
  if (v && v != "") return v;
  return myPlugId;
}
//接收到外部的消息
export function StartReceiveWindowsMessage(cb) {
  var isGetMessage = false;
  window.addEventListener(
    "message",
    function (e) {
      if (!e.data || e.data.from != "zzb") return;
      if (e.data.from2 == "injectResult") return reviceMsginjectResultCb && reviceMsginjectResultCb(e.data.data);
      if (isGetMessage) return;
      console.log("开始获取message里的数据");
      isGetMessage = true;
      console.log(e.data);
      if (e.data.plugId) PU_SetPlugId(e.data.plugId);
      if (e.data.isAggressXieYi) SetAgreeXueYiOK();
      if (e.data.token) {
        // (e.data.token)
      }
      //
      if (e.data.pddInfo) {
        // message.info(JSON.stringify(e.data.pddInfo))
        // SaveMyToken(e.data.pddInfo)
      }

      cb && cb(e.data);
    },
    false
  );
}

var reviceMsginjectResultCb = null;
//发送的请求。。完成回调
export async function PU_RequestInjectData(postData, resultCacheDataKey, myOpenViewId, newPostMsgIframeClass) {
  reviceMsginjectResultCb = null;
  var postMsgIframeClass = `#${myOpenViewId} iframe`;
  if (newPostMsgIframeClass) postMsgIframeClass = newPostMsgIframeClass;
  return new Promise((r) => {
    var msgId = new Date().getTime() + "InjectDataMsgId";
    var returnParams = { postMsgIframeClass, postMsgUrl: window.location.href, msgId };
    var injectInfo = { postData, resultCacheDataKey };
    var data = { returnParams, injectInfo };
    reviceMsginjectResultCb = null;
    reviceMsginjectResultCb = (resultData) => {
      if (
        !resultData.originData ||
        !resultData.originData.returnParams ||
        resultData.originData.returnParams.msgId != msgId
      )
        return;
      reviceMsginjectResultCb = null;
      r(resultData);
    };
    MsgUtil_RequestInjectData(data);
  });
}
var currentManifestInfo = null;
async function PU_GetManifestInfo(cb) {
  if (currentManifestInfo) return cb && cb(currentManifestInfo);
  var m = await PU_Request2("getManifest", {});
  var v = parseFloat(m["version"]);
  if (m["version"] == "5.5.1") v = 5.51;
  currentManifestInfo = m;
  currentManifestInfo.version2 = v;
  return currentManifestInfo;
}

//检查是不是当前的版本
export async function PU_CheckLowVersion(lowVersion) {
  var info = await PU_GetManifestInfo();
  return info && info.version2 >= lowVersion;
}

export async function PU_GotoNextUrl(url) {
  window.open(url, "_blank");
  //如果当前是5.6则用request，否则就是open
  // var isOK = await PU_CheckLowVersion(5.6)
  // if(!isOK) return window.open(url,"_blank")
  // await PU_Request2("createTab", { url })
}

export function PU_SetPlugId(pId) {
  if (!pId) return;
  //判断当前是不是对的
  myPlugId = pId;
  localStorage.setItem("zzbPlugId", myPlugId);
  PU_CheckOK().then((ok) => {
    if (!ok) {
      myPlugId = null;
      message.error("您必须要安装正版插件才可以正常使用");
      return;
    }
    console.log("添加了我的plugId" + myPlugId);
  });
}
export function PU_HasPlug() {
  if (!chrome || !chrome.runtime || !chrome.runtime.sendMessage) {
    return false;
  }
  try {
    chrome.runtime.sendMessage(getPlugId(), { cmd: "test" });
  } catch (e) {
    return false;
  }
  return true;
}

// export async function PU_ExeCss(cssCode){
//     var key = md5(cssCode)
//     var param = {key,code:cssCode}
//     return await PU_Request2("executeCss",param)
// }
//发消息
export async function PU_SendMsg(data) {
  return await PU_Request2("sendMessageToContentScript", data);
}

// export async function PU_ExeJs(jsCode){
//     var key = md5(jsCode)
//     var param = {key,code:jsCode}
//     return await PU_Request2("executeJs",param)
// }

export async function PU_HttpPost(param) {
  param.method = "post";
  return await PU_Request2("ajax", param);
}
export async function PU_HttpGet(param) {
  return await PU_Request2("ajax", param);
}
export async function PU_Request2(cmd, data) {
  var p = new Promise((r) => {
    PU_Request(cmd, data, (a) => {
      r(a);
    });
  });
  return p;
}
export async function PU_HttpPut(param) {
  param.method = "put";
  return await PU_Request2("ajax", param);
}
//检查所有的植入数据
export function PU_InitViewCheck(cb, viewThis) {
  if (viewThis && viewThis.$route && viewThis.$route.query && viewThis.$route.query.plugId) {
    debugger;
    PU_SetPlugId(viewThis.$route.query.plugId);
  }
  PU_CheckOK();
  StartReceiveWindowsMessage(cb);
}

//是否是其他插件。。而不是自己的
export async function PU_CheckOtherPlug() {
  var m = await PU_Request2("getManifest");
  console.log(m);
  var names = ["虾爆单", "省多多", "虾找品", "暴走蜗牛", "多大师", "生财金米"];
  var hasName = false;
  var myName = "";
  names.map((name) => {
    if (!hasName && m && m.name.indexOf(name) >= 0) {
      hasName = true;
      myName = name;
    }
  });
  if (hasName) return { isOther: true, name: myName };
  return { isOther: false };
}

const showMsg = () => {
  setTimeout(() => {
    const isShowMsg =
      !location.hash.includes("member/login") &&
      !location.hash.includes("register_success") &&
      !location.hash.includes("register") &&
      !location.hash.includes("promotionCommission") &&
      !location.hash.includes("integralRecord");
    isShowMsg && message.error("您必须要安装正版插件才可以正常使用");
  }, 5);
};

//检查是不是存在
export async function PU_CheckOK() {
  var m = await PU_Request2("getManifest");
  var names = ["至尊宝", "虾爆单", "省多多", "虾找品", "暴走蜗牛", "多大师", "生财金米"];
  var hasName = false;
  names.map((name) => {
    if ((!hasName && m && m.name.indexOf(name) >= 0) || (m && m.author == "zzb")) hasName = true;
  });
  if (hasName) return true;
  //如果没有至尊宝这三个则有问题
  // message.error("您必须要安装插件才可以正常使用"+JSON.stringify(m)+myPlugId)
  showMsg();
  return false;
}
//检测版本是不是对的
export async function PU_CheckVerionOK(lowV) {
  var isOK = await PU_CheckOK();
  if (!isOK) return;
  var m = await PU_Request2("getManifest");
  var v = parseFloat(m["version"]);
  return v >= lowV;
}

export function PU_Request(cmd, data, cb) {
  if (!data) data = {};
  if (!cb) cb = () => {};
  data.cmd = cmd;
  if (!chrome || !chrome.runtime || !chrome.runtime.sendMessage) {
    showMsg();
    cb(false, "您还没有安装插件");
    return;
  }
  //console.log("plugId="+getPlugId())
  // chrome.runtime.sendMessage("ifeahmbpkackncmnogjaimncfcaimmkl", data, cb);
  chrome.runtime.sendMessage(getPlugId(), data, cb);
}

export function PU_GetCacheData(cacheKey, cb) {
  PU_Request("GetCacheData", { key: cacheKey }, cb);
}

export function PU_SetCacheData(cacheKey, cacheValue, cb) {
  PU_Request("SetCacheData", { key: cacheKey, value: cacheValue }, cb);
}

//清空浏览器缓存
export function PU_RemoveChromLocal() {
  console.log(chrome);
  console.log(chrome.storage);
  // chrome.storage.local.clear()
  chrome.storage.local.clear();
}

//获取插件信息
export async function PU_GetPlugInfo() {
  let plugInfo = await PU_Request2("getManifest");
  console.log(plugInfo);
  return plugInfo;
}

//获取插件形参上的插件id
export async function PU_SetPlugOfHref() {
  let hash = window.location.hash;
  let query = getUrlParam(hash);
  if (query?.plugId) PU_SetPlugId(query?.plugId);
}
// 获取链接上参数
function getUrlParam(url) {
  let param = {};
  if (url.indexOf("?") != -1) {
    let str = url.substring(url.indexOf("?") + 1);
    const strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      param[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
    }
  }
  return param;
}
